import FindLangKey from "Global/Functions/FindLangKey/FindLangKey";

export const dictionary = () => {
  const uploadReceipt = FindLangKey("freeze-contracts-btn-upload-bank-receipt");
  const receiptList = FindLangKey("freeze-contracts-btn-get-receipt-list");
  return { uploadReceipt, receiptList };
};
